import { PreservedText, SupportHL7Message } from '@enter/core';
import * as S from './claim-timeline-table.styles';
import React from 'react';

interface IHL7MessageDetailProps {
    hl7Message: SupportHL7Message;
}

export const HL7MessageDetail: React.FunctionComponent<IHL7MessageDetailProps> = (
    props: IHL7MessageDetailProps,
): React.ReactElement => {
    const { hl7Message } = props;
    const message = (hl7Message.message || '').replace(/\r|\n/g, '\n');
    return (
        <S.ExpandContainer>
            <S.ExpandLabel>HL7 Message</S.ExpandLabel>
            <PreservedText text={message} />
            <S.Divider />
            <S.ExpandLabel>HL7 Response</S.ExpandLabel>
            <PreservedText text={hl7Message.response} />
        </S.ExpandContainer>
    );
};
